(function(angular){
	'use strict';
	
	angular.module('progressIndicatorModule', []);

})(window.angular);